import React, { FC, ComponentType } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Loading from '../components/Loading';

interface ProtectedRouteProps {
  component: ComponentType;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
  component: Component,
}) => {
  const AuthenticatedComponent = withAuthenticationRequired(Component, {
    onRedirecting: () => <Loading heading="Loading" text="Please wait" />,
  });

  return <AuthenticatedComponent />;
};
